module.exports = __webpack_public_path__ + "img/comprobantes.4135b97f.png";